export default () => {
  const error = document.querySelectorAll('.error');

  error.forEach((e) => {
    const parent = e.parentElement;
    const errorInput = parent.querySelectorAll('input[type="text"],input[type="email"],input[type="checkbox"],select,textarea');
    errorInput.forEach((el) => {
      const t = el;
      t.classList.add('is-error');
      t.addEventListener('focus', (elm) => {
        elm.target.classList.remove('is-error');
      });
    });
  });

  const errorElm = document.querySelector('.is-error');

  document.addEventListener('load', () => {
    if (errorElm) {
      errorElm.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }
  });
};
